// extracted by mini-css-extract-plugin
module.exports = {"SecondStep":"SecondStep_SecondStep__AEW6O","ColoredBlock":"SecondStep_ColoredBlock__1UDQP","CustomNumClass":"SecondStep_CustomNumClass__2ocFA","Title":"SecondStep_Title__2MfSt"};